import ArrowDropdown from "./ArrowDropdown";
import CloseX from "./CloseX";
import Download from "./Download";
import Fullscreen from "./Fullscreen";
import FullscreenExit from "./FullscreenExit";
import Edit from "./Edit";
import AddRound from "./AddRound";
import ArrowLeftRight from "./ArrowLeftRight";
import ArrowNext from "./ArrowNext";
import ArrowPrev from "./ArrowPrev";
import BellIcon from "./BellIcon";
import Image from "./Image";
import Loading from "./Loading";
import MoveDown from "./MoveDown";
import MoveUp from "./MoveUp";

const EXPORT = {
  ArrowDropdown,
  AddRound,
  CloseX,
  Download,
  Fullscreen,
  FullscreenExit,
  Edit,
  ArrowLeftRight,
  ArrowNext,
  ArrowPrev,
  BellIcon,
  Image,
  Loading,
  MoveDown,
  MoveUp,
};

export default EXPORT;
